import { createConsumer } from '@rails/actioncable';
import TasksAPI from 'dashboard/api/tasks';

class TaskChannelConnector {
  constructor(store) {
    this.store = store;
    this.workspaceId = store.getters.getCurrentAccountId;
    const { websocketURL = '' } = window.chatwootConfig || {};
    const cableURL = websocketURL ? `${websocketURL}/cable` : undefined;

    this.consumer = createConsumer(cableURL);
    this.subscription = this.consumer.subscriptions.create(
      {
        channel: 'TaskChannel',
        workspace_id: this.workspaceId,
      },
      {
        connected: this.onConnected,
        received: this.onReceived,
      }
    );
  }

  onConnected = () => {
    this.replayMissedEvents();
  };

  onReceived = event => {
    if (!event) {
      return;
    }

    this.store.dispatch('tasks/handleEvent', event);
  };

  async replayMissedEvents() {
    const params = {
      workspace_id: this.workspaceId,
    };

    const lastTimestamp = this.store.getters['tasks/getLastEventTimestamp'];
    if (lastTimestamp) {
      params.since = lastTimestamp;
    }

    try {
      const response = await TasksAPI.replayEvents(params);
      const events = response.data?.events || [];
      if (events.length) {
        this.store.dispatch('tasks/replayEvents', events);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to replay task events', error);
    }
  }

  disconnect() {
    this.consumer.disconnect();
  }
}

let connector;

const waitForAccount = store =>
  new Promise(resolve => {
    const poll = () => {
      if (store.getters.getCurrentAccountId) {
        resolve();
      } else {
        setTimeout(poll, 300);
      }
    };
    poll();
  });

export default {
  async init(store) {
    if (connector) {
      return connector;
    }

    await waitForAccount(store);
    connector = new TaskChannelConnector(store);
    return connector;
  },

  disconnect() {
    if (connector) {
      connector.disconnect();
      connector = null;
    }
  },
};
